













































import { SimpleFilter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { VueCssClasses } from '../../../utils';

@Component({
  name: 'CheckBoxFilter'
})
export default class CheckBoxFilter extends Vue {

  @Prop()
  private filter: SimpleFilter;

  @Prop()
  private titleComponent: string;

  @Prop()
  private checkboxIconComponent: string;

  @Prop({ default: false })
  private showMoreButton: boolean;

  @Prop({ default: 5 })
  private filtersToShow: number;

  @Prop({ default: 'li' })
  private tag: string;

  @Prop({ default: false })
  useIndexAsFilterKey: boolean;

  @Prop({ default: true })
  private renderChildren: boolean;

  private showFilters = false;

  get cssClasses(): VueCssClasses {
    return {
      'ebx-checkbox-filter': !!this.checkboxIconComponent,
      'ebx-filter--selected': this.filter.selected,
      'ebx-filter--indeterminate': this.indeterminate,
      'ebx-filter--no-results': this.hasNoResults
    };
  }

  get hasNoResults(): boolean {
    return this.filter.count === 0;
  }

  get ariaLabel() {
    return this.$options.filters.compileMessage(this.$x.messages.facets.itemCounter, { value: this.filter.count });
  }

  get visibleChildren(): SimpleFilter[] {
    if (this.showMoreButton && this.filter.children && !this.showFilters) {
      return this.filter.children.slice(0, this.filtersToShow);
    }
    return this.filter.children;
  }

  get renderShowMoreButtons(): boolean {
    return this.showMoreButton && this.filter.children && this.filtersToShow < this.filter.children.length;
  }

  get indeterminate(): boolean {
    const selectedChildrenCount = this.filter.children.filter(child => child.selected).length;
    return selectedChildrenCount > 0 && selectedChildrenCount < this.filter.children.length;
  }

  onClick() {
    this.$x.emit(EVENTS.FilterClicked, this.filter);
  }

  onShowMoreClick() {
    this.showFilters = true;
  }

  onShowLessClick() {
    this.showFilters = false;
  }
}
